// Auto-generated during build process
export const APP_VERSION = '20261104.01-0eb1dbd';